import { render, staticRenderFns } from "./DisplaySkillItem.vue?vue&type=template&id=979e8a9e&lang=pug&"
import script from "./DisplaySkillItem.vue?vue&type=script&lang=ts&"
export * from "./DisplaySkillItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979e8a9e')) {
      api.createRecord('979e8a9e', component.options)
    } else {
      api.reload('979e8a9e', component.options)
    }
    module.hot.accept("./DisplaySkillItem.vue?vue&type=template&id=979e8a9e&lang=pug&", function () {
      api.rerender('979e8a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DisplaySkillItem.vue"
export default component.exports